// Hide Header on scroll-down & Show on scroll-up

let headerHeight = document.querySelector("#myheader").offsetHeight;
let headerHeightPX = "-" + headerHeight + "px";
let prevScrollpos = window.pageYOffset;

$(document).scroll(function () {
  if (window.pageYOffset > 10) {
    window.onscroll = function () {
      let currentScrollPos = window.pageYOffset;
      if (prevScrollpos > currentScrollPos) {
        document.getElementById("myheader").style.top = "0";
      }
      // Fix for Safari & other mobile browsers for negative YOffset values
      else if (window.pageYOffset <= 0) {
        document.getElementById("myheader").style.top = "0";
      } else {
        document.getElementById("myheader").style.top = headerHeightPX;
      }
      prevScrollpos = currentScrollPos;
    };
  }
});

// gsap scroll trigger for about page

console.log("gsap init...");
gsap.utils.toArray(".about-section").forEach((panel, i, index) => {
  let vh = window.innerHeight;
  let dynVh = $(window).height();
  let height = $(panel).height();
  let difference = height - dynVh;

  //  start: () => innerHeight - ' top' top

  ScrollTrigger.create({
    trigger: panel,
    start: difference + "top",
    end: "+=100%",
    pin: true,
    pinSpacing: false,
    markers: false,
  });
});

// Tabs Logic

$('.tabs-stage > div').hide();
$(".tabs-stage div:first").fadeIn(500);
$(".tabs-nav li:first").addClass("tab-active");
$(".tabs-stage div:first > div").fadeIn(500);

// Change tab class
$(".tabs-nav a").on("click", function (event) {
  event.preventDefault();
  $(".tabs-nav li").removeClass("tab-active");
  $(this).parent().addClass("tab-active");
  
  // Hide all tab content and their children
  $(".tabs-stage > div").hide();
  $(".tabs-stage > div > div").hide();
  
  // Show the selected tab and its children
  let targetTab = $($(this).attr("href"));
  targetTab.fadeIn(500);
  targetTab.find("> div").fadeIn(500);
});

// Specific handlers for tab3link and tab1link
$("#tab3link").on("click", function() {
  $("#tab-4").hide();
});

$("#tab1link").on("click", function() {
  $("#tab-4").hide();
});

// Display content of tabs
if ($("#tab1link").length > 0) {
  document.querySelector("#tab1link").addEventListener("click", () => {
    $("#tab-1 > div").fadeIn(500);
  });
}
if ($("#tab2link").length > 0) {
  document.querySelector("#tab2link").addEventListener("click", () => {
    $("#tab-2 > div").fadeIn(500);
  });
}
if ($("#tab3link").length > 0) {
  document.querySelector("#tab3link").addEventListener("click", () => {
    $("#tab-3 > div").fadeIn(500);
  });
}
if ($("#tab4link").length > 0) {
  document.querySelector("#tab4link").addEventListener("click", () => {
    $("#tab-4 > div").fadeIn(500);
  });
}
if ($("#tab5link").length > 0) {
  document.querySelector("#tab5link").addEventListener("click", () => {
    $("#tab-5 > div").fadeIn(500);
  });
}

$(document).ready(function () {
  {
    $(".chevronAfter").addClass("chevronUpAfter");
  }
});

let chevronAfters = document.querySelectorAll(".chevronAfter");
chevronAfters.forEach((chevronAfter) => {
  chevronAfter.addEventListener("click", function handleClick(e) {
    chevronAfter.classList.toggle("chevronUpAfter");
    chevronAfter.classList.toggle("chevronDownAfter");
  });
});

// Add to Cart Collection page
function addCart(id) {
  jQuery.post(window.Shopify.routes.root + "cart/add.js", {
    items: [
      {
        quantity: 1,
        id: id,
      },
    ],
  });
  var url = $(location).attr("href");
  if (url.indexOf("?added") >= 0) {
    window.location.href = url;
  } else {
    window.location.href = url + "?added";
  }
}

$(document).ready(function () {
  var x = $(location).attr("search");
  if (x == "?added") {
    $(".js-drawer-open-cart")[0].click();
  }
});

// Preloader

// Content Slider PDP

// jQuery
// let $carousel = $('.content-carousel').flickity({
//   imagesLoaded: true,
//   setGallerySize: false,
//   bgLazyLoad: true,
//   cellAlign: "center"
//   });

// var elem = document.querySelector('.content-carousel');
// var flkty = new Flickity( elem, {
//   // options
//   contain: true,
//   imagesLoaded: true,
//   setGallerySize: false,
//   bgLazyLoad: true,
//   cellAlign: "center"
// });

// window.ReChargeWidget.createWidget(configEE);

// $('.add-to-cart-button--coll').click(function(){
//   addItemToCart(7227396817092, 1, "1", "Months")
// });

// function addItemToCart(variant_id, qty, frequency, unit_type) {
//   data = {
//     "id": variant_id,
//     "quantity": qty,
//     "properties": {
//       "shipping_interval_frequency": frequency,
//       "shipping_interval_unit_type": unit_type
//     }
//   }
//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: data,
//     dataType: 'json',
//     success: function() {
//       window.location.href = '/cart';
//     }
//   });
//   window.location = '/checkout';
// }

  




// BG Lazy Load

document.addEventListener("DOMContentLoaded", function () {
  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function (image) {
      imageObserver.observe(image);
    });
  } else {
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload() {
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function () {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function (img) {
          if (img.offsetTop < window.innerHeight + scrollTop) {
            img.src = img.dataset.src;
            img.classList.remove("lazy");
          }
        });
        if (lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
});


// Flickity Lighthouse Fix

class FlickPatch {  //  Flick Carousel ARIA-HIDDEN observer
    constructor(_d, _sQ) {
        this._d = _d; this._sQ = _sQ;
        this.aF = []; this.aObs = [];
    }
    init() {  //
        this.aF = Array.from( this._d.querySelectorAll( this._sQ ))
        if( this.aF.length ){
            this.aObs = []
            this.aF.forEach( ( eF )=>{
                const oObs = new MutationObserver( flickPatch.removeAttr );
                oObs.observe( eF, { attributes: true, childList: true, subtree: true } );
                this.aObs.push( oObs )
            })            
        }
        return this;
    }
    removeAttr( aObs ){  //
        if( aObs.length ){
            aObs.forEach( ( elO )=>{
                if( elO?.target ){
                    [ ... elO.target.querySelectorAll( "[aria-hidden='true']" )].forEach( ( eH )=>{
                        eH.removeAttribute("aria-hidden")
                    })
                }
            })
        }
    }
}
//. Usage
let flickPatch = {}
document.addEventListener("DOMContentLoaded", ( ev )=>{
    setTimeout( ()=>{
        flickPatch = new FlickPatch( document, ".flickity-slider" )
        flickPatch.init()   
    }, 8e3 )
})



// Custom Background Handler
function handleCustomBackground() {
  // Check if we're in a lightbox
  const isInLightbox = document.querySelector('.lightbox') !== null;
  
  // Only proceed if we're not in a lightbox
  if (!isInLightbox) {
    // Get the background section if it exists
    const backgroundSection = document.querySelector('[data-section-type="alrighty--custom-bg"]');
    
    if (backgroundSection) {
      // Get the background image URL and settings
      const backgroundImage = backgroundSection.querySelector('[data-background-image]')?.dataset.backgroundImage;
      const focalPoint = backgroundSection.querySelector('[data-focal-point]')?.dataset.focalPoint || 'center center';
      const overlayColor = backgroundSection.querySelector('[data-overlay-color]')?.dataset.overlayColor || '#000000';
      const overlayOpacity = backgroundSection.querySelector('[data-overlay-opacity]')?.dataset.overlayOpacity || 0;
      
      // Apply background to body
      if (backgroundImage) {
        document.body.style.background = `url('${backgroundImage}')`;
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundPosition = focalPoint;
      }
      
      // Create and append overlay
      const overlay = document.createElement('div');
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = overlayColor;
      overlay.style.opacity = overlayOpacity / 100;
      overlay.style.pointerEvents = 'none';
      overlay.style.zIndex = 'auto';
      
      // Insert overlay before MainContent
      const mainContent = document.getElementById('MainContent');
      if (mainContent) {
        mainContent.parentNode.insertBefore(overlay, mainContent);
      }
    }
  } else {
    // If we are in a lightbox, ensure the background is removed
    document.body.style.background = 'none';
    const existingOverlay = document.querySelector('#MainContent').previousElementSibling;
    if (existingOverlay && existingOverlay.style.position === 'fixed') {
      existingOverlay.remove();
    }
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', handleCustomBackground);

// Add to reinitializeScripts function
function reinitializeScripts(container) {
  // ... existing reinitializeScripts code ...
  
  // Re-initialize custom background
  handleCustomBackground();
  
  // ... rest of existing reinitializeScripts code ...
}


